import {ConvertDentsToMillimetersParameters} from './convert-dents-to-millimeters-parameters';

export function convertDentsToMillimeters(convertDentsToMillimetersParameters: ConvertDentsToMillimetersParameters): number {
  return Math.round(convertDentsToMillimetersParameters.valueInDents / convertDentsToMillimetersParameters.factorForConversionFromMillimetersToDents);
}
